/**
 * Internal reference for the render function
 *
 * @internal
 */ export const SLOT_RENDER_FUNCTION_SYMBOL = Symbol.for('fui.slotRenderFunction');
/**
 * Internal reference for the render function
 *
 * @internal
 */ export const SLOT_ELEMENT_TYPE_SYMBOL = Symbol.for('fui.slotElementType');
/**
 * Internal cache of the original className prop for the slot, before being modified by the useStyles hook.
 *
 * @internal
 */ export const SLOT_CLASS_NAME_PROP_SYMBOL = Symbol.for('fui.slotClassNameProp');
